export default __webpack_public_path__ + "static/media/finna.db3d20b1.png";